export default __webpack_public_path__ + "static/media/RAKSHITA_KAI_SCIENCE.9b4c0e72.JPG";